/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./update-demand-dialog.vue?vue&type=template&id=240cd72b&"
import script from "./update-demand-dialog.vue?vue&type=script&lang=js&"
export * from "./update-demand-dialog.vue?vue&type=script&lang=js&"
import style0 from "./update-demand-dialog.vue?vue&type=style&index=0&id=240cd72b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports